import type { RouteObject } from 'react-router-dom'

import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import List from './components/List'
import Create from './components/Create'
import Update from './components/Update'

const RolesModule: RouteObject = {
    path: 'roles',
    children: [
        {
            path: '',
            children: [
                { path: '', element: <List /> },
                { path: 'new', element: <Create /> },
                {
                    path: ':roleName',
                    children: [{ path: '', element: <Update /> }],
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default RolesModule
